/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */
export class Breadcrumb {
  _pageTitle: string = "";
  _parent1: string = "";
  _parent2: string = "";
  _parent3: string = "";
  _parent1_link: string = "";
  _parent2_link: string = "";
  _parent3_link: string = "";
}